// extracted by mini-css-extract-plugin
export default {"content":"styles_content__mIlg3","divider":"styles_divider__UDbUh"};